import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { slugify } from "../../../../Shared/utils/string";
export const ExpandItem = (props)=>/*#__PURE__*/ _jsx("li", {
        className: "expand__item",
        children: /*#__PURE__*/ _jsxs("details", {
            className: "expand__wrap",
            children: [
                /*#__PURE__*/ _jsxs("summary", {
                    className: "expand__button",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "expand__item--title",
                            children: props.title
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "expand__item--label",
                            children: "Lees meer"
                        })
                    ]
                }),
                props.child != null ? /*#__PURE__*/ _jsx("div", {
                    id: `a11y-${slugify(props.key)}`,
                    className: "expand__content container--s text--styled",
                    children: props.child
                }) : /*#__PURE__*/ _jsx("div", {
                    id: `a11y-${slugify(props.key)}`,
                    dangerouslySetInnerHTML: {
                        __html: props.text
                    },
                    className: "expand__content container--s text--styled"
                })
            ]
        })
    }, slugify(props.key));
{}